// extracted by mini-css-extract-plugin
export default {"rules_container":"FileUploadHistoryRules_rules_container__lbTgA","sample_data_container":"FileUploadHistoryRules_sample_data_container__mZpF4"};